module.exports = __webpack_public_path__ + "static/media/baby-svgrepo-com.580dd60f.svg";